<div class="row">
    <div class="col-lg-12 col-xxl-12">
        <div class="row">
            <div class="col-sm-2 col-xxl-2" *ngFor="let folders of folders_list">
                <mat-card class="mb-25 tagus-card card-box">
                    <mat-card-header class="mb-0">
                        <span></span>
                        <button type="button" mat-button 
                            class="position-relative dot-btn p-0 bg-transparent border-none" 
                            [matMenuTriggerFor]="monthMenu">
                            <i class="ri-more-fill"></i>
                        </button>
                        <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                            <button mat-menu-item 
                                type="button" 
                                class="bg-transparent border-none position-relative"
                                (click)="updateFolder(folders)">
                                <i class="ri-edit-line"></i> Rename
                            </button>
                            <button mat-menu-item 
                                type="button" 
                                class="bg-transparent border-none position-relative"
                                (click)="deleteConfirmation(drive_action_type.folder, folders)">
                                <i class="ri-delete-bin-line"></i> Remove
                            </button>
                        </mat-menu>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="pt-50 pb-50 text-center cursor-pointer" (click)="navigateToFolders(folders)">
                            <img src="assets/img/icon/folder.png" alt="folder">
                            <span class="d-block fw-semibold mt-10">
                                <a href="javascript:void(0)">
                                    <ng-container *ngIf="folders?.name?.length > 15; else small">
                                        <span [matTooltip]="folders?.name">{{folders?.name | slice:0:15}}...</span>
                                    </ng-container>
                                    <ng-template #small>
                                        {{folders?.name}}
                                    </ng-template>
                                </a>
                            </span>
                        </div>
                        <div class="d-flex justify-content-space-between align-items-center">
                            <span class="d-block gray-color">{{folders?.count}} Files</span>
                            <span class="d-block gray-color">
                                <span class="d-block main-color">
                                    <ng-container *ngIf="folders?.allotment === '4'; else no_imp">
                                        <i class="flaticon-star-1 me-10 fs-16 cursor-pointer" 
                                            (click)="important(drive_action_type.folder, drive_action_type.unimportant, folders)"></i>
                                    </ng-container>
                                    <ng-template #no_imp>
                                        <i class="flaticon-star me-10 fs-16 cursor-pointer" 
                                        (click)="important(drive_action_type.folder, drive_action_type.important, folders)"></i>
                                    </ng-template>
                                    <i class="ri-share-line fs-16 cursor-pointer"
                                        *ngIf="drive_title !== drive_titles.shared_with_me"
                                        (click)="share(drive_action_type.folder, drive_action_type.share, folders)"></i>
                                </span>
                            </span>
                        </div>
                    </mat-card-content>
                </mat-card>
            </div>
            <div class="col-sm-12 col-xxl-12" *ngIf="folder_pagination_config?.total === 0">
                <mat-card class="mb-25 tagus-card card-box">
                    <h6 class="text-center fw-semibold">
                        {{payload_entity_grid_folders.search ? 'No search result found' : 'No folder added yet'}}
                    </h6>
                </mat-card>
            </div>
        </div>
        
        <h6 class="text-center mb-20" 
            *ngIf="folder_pagination_config?.total > 12 && folders_list?.length !== folder_pagination_config.total">
            <a href="javascript:void(0)" class="main-color" (click)="viewMore(drive_action_type.folder)">View more</a>
        </h6>

        <mat-card class="mb-25 tagus-card">
            <mat-card-header>
                <h5 class="mb-0">Files</h5>
                <!-- <button mat-flat-button class="default-btn tagus" (click)="createFile()">
                    <i class="ri-add-fill"></i> Upload File
                </button> -->
            </mat-card-header>
            <mat-card-content>
                <div class="files-list d-flex flex-wrap">
                    <div class="file-item" *ngFor="let files of files_list">
                        <div class="bg-gray text-center mt-15 ps-20 pe-20 pt-10 pb-30 border-radius">
                            <div class="d-flex justify-content-space-between align-items-center mb-20">
                                <span class="d-block main-color">
                                    <ng-container *ngIf="files?.allotment === '4'; else no_imp">
                                        <i class="flaticon-star-1 me-10 fs-16 cursor-pointer" 
                                        (click)="important(drive_action_type.file, drive_action_type.unimportant, files)"></i>
                                    </ng-container>
                                    <ng-template #no_imp>
                                        <i class="flaticon-star me-10 fs-16 cursor-pointer" 
                                        (click)="important(drive_action_type.file, drive_action_type.important, files)"></i>
                                    </ng-template>
                                    <i class="ri-share-line fs-16 cursor-pointer"
                                        *ngIf="drive_title !== drive_titles.shared_with_me"
                                        (click)="share(drive_action_type.file, drive_action_type.share, files)"></i>
                                </span>
                                <button type="button" 
                                    mat-button class="position-relative dot-btn p-0 bg-transparent border-none file-menu"
                                    [matMenuTriggerFor]="monthMenu">
                                    <i class="ri-more-fill fs-20"></i>
                                </button>
                                <mat-menu #monthMenu="matMenu" class="dotMenu monthMenu" xPosition="before">
                                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative" (click)="download(files)">
                                        <i class="ri-download-cloud-2-line"></i> Download
                                    </button>
                                    <button mat-menu-item type="button" class="bg-transparent border-none position-relative"
                                        (click)="deleteConfirmation(drive_action_type.file, files)">
                                        <i class="ri-delete-bin-line"></i> Remove
                                    </button>
                                </mat-menu>
                            </div>
                            <span *ngIf="files?.icon">
                                <img src="assets/img/icon/{{files?.icon}}" alt="jpg">
                            </span>
                          
                            <span *ngIf="!files?.icon">
                                <img src="assets/img/icon/doc.png" alt="icon1">
                            </span>
                            
                            <span class="d-block fw-semibold mt-15 gray-color">
                                <a href="javascript:void(0)" class="gray-color" (click)="download(files)">
                                    <ng-container *ngIf="files?.name?.length > 15; else small">
                                        <span [matTooltip]="files?.name">{{files?.name | slice:0:15}}...</span>
                                    </ng-container>
                                    <ng-template #small>
                                        {{files?.name}}
                                    </ng-template>
                                </a>
                            </span>
                        </div>
                    </div>
                </div>
                <h6 class="text-center mt-20 fw-semibold" *ngIf="file_pagination_config.total === 0">
                    {{payload_entity_grid_files.search ? 'No search result found' : 'No file added yet'}}
                </h6>
                <h6 class="text-center mt-20" 
                    *ngIf="file_pagination_config.total > 10 && files_list?.length !== file_pagination_config.total">
                    <a href="javascript:void(0)" class="main-color" (click)="viewMore('file')">View more</a>
                </h6>
            </mat-card-content>
        </mat-card>
    </div>
</div>